export var jumpMixins = {
  methods: {
    toLogin: function toLogin() {
      if (this.$route.name == 'login' || this.$route.name == 'find' || this.$route.name == 'register') {
        this.$router.push({
          name: 'login'
        });
      } else if (this.$route.query.backUrl) {
        this.$router.push({
          name: 'login',
          query: {
            backUrl: this.$route.query.backUrl
          }
        });
      } else {
        this.$router.push({
          name: "login",
          query: {
            backUrl: window.document.location.pathname + window.document.location.search
          }
        });
      }
      // window.location.href = "https://newpassport.cyscc.org/login?back_url=" + window.location.href
    },
    toRegister: function toRegister() {
      if (this.$route.name == 'login' || this.$route.name == 'find' || this.$route.name == 'register') {
        this.$router.push({
          name: 'register'
        });
      } else if (this.$route.query.backUrl) {
        this.$router.push({
          name: 'register',
          query: {
            backUrl: this.$route.query.backUrl
          }
        });
      } else {
        this.$router.push({
          name: "register",
          query: {
            backUrl: window.document.location.pathname + window.document.location.search
          }
        });
      }
      // window.location.href = "https://newpassport.cyscc.org/signup?back_url=" + window.location.href
    },
    toCenter: function toCenter() {
      // window.open("https://cyscc.org/#/mine?token=" + this.cycssToken)
      this.$router.push("/user");
    }
  }
};